<template>
  <!-- 成绩数据模块  -->
  <div class="grade-data">
    <div class="tea-search">
      <el-form ref="form" :inline="true" class="demo-form-inline" size="small" v-if="model_type!=4">
        <!-- 选择集训场次 -->
        <el-form-item v-show="model_type!=3||history_group_show">
          <el-date-picker :picker-options="pickerOptions" v-model="time_list" type="daterange" :clearable='false'
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          @change="timeChange()">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="search-text" style="width:300px">
            <el-input
                :placeholder="model_type==3||model_type==5?'请输入小组名称或关键字查询':'请输入学生姓名或关键字查询'"
                v-model="search_data.xsxm" class="input-with-select">
            </el-input>
          </div>
        </el-form-item>
        <el-form-item class="fr">
          <el-button icon="el-icon-search" type="primary" class="fl tea-btn" @click="handelSearch()">查 询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="model-type">
      <el-radio-group v-model="model_type" style="margin-bottom: 20px;" @change="tabClick">
        <el-radio-button :label="1">班级成绩</el-radio-button>
        <el-radio-button :label="2">测试成绩</el-radio-button>
        <el-radio-button :label="3">小组成绩</el-radio-button>
        <el-radio-button :label="4">每日汇总</el-radio-button>
      </el-radio-group>
      <div class="btns">
        <el-button type="primary" class="fr tea-btn" @click="history_group_show=false,tabClick()"
                   v-if='model_type==3&&(history_group_show)'>当前小组成绩
        </el-button>
        <el-button type="primary" class="fr tea-btn" @click="getHistoeyGroupList()"
                   v-show="model_type==3&&(!history_group_show)">历史小组成绩
        </el-button>
        <el-button type="primary" class="fr tea-btn" @click="screenShow()"
                   v-show="model_type==3&&(!history_group_show)">分屏显示
        </el-button>
        <el-button type="primary" class="fr tea-btn" icon="el-icon-view" @click="lookReport" v-if="false"
                   v-show="model_type==1&&(!history_group_show)">生成报告
        </el-button>
        <el-button type="primary" class="fr tea-btn" @click="exportToExcelClass"
                   v-show="model_type==1&&(!history_group_show)">导出excel
        </el-button>
        <el-button type="primary" class="fr tea-btn" icon="el-icon-view" @click="lookSummaryReport" v-if="false"
                   v-show="model_type==4&&(!history_group_show)">
          生成报告
        </el-button>
        <el-button type="primary" class="fr tea-btn" @click="exportToExcel"
                   v-show="model_type==4&&(!history_group_show)">导出excel
        </el-button>

      </div>
    </div>
    <div class="grade-box">

      <!-- 班级成绩 -->
      <div class="table" v-show="model_type==1">
        <el-table stripe border :data="classGradeData" height="calc(100% - 40px)" @sort-change="handleSortChange">
          <el-table-column type="index" label="序号" align="center" width="50" :index="indexMethod"/>
          <el-table-column prop="xsxm" label="姓名" align="center"/>
          <!-- <el-table-column prop="xjh" label="学籍号" align="center" /> -->
          <el-table-column prop="xb" label="性别" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.xb==1"><i class="el-icon-male" style="color:#67C23A;font-size:18px"></i> 男</div>
              <div v-else-if="scope.row.xb==2"><i class="el-icon-female" style="color:#F56C6C;font-size:18px"></i> 女
              </div>
              <div v-else>未知</div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="bjmc" width="160px" label="常规班" align="center"/>
          <el-table-column sortable prop="yzwl" label="已掌握词汇量" align="center"/>
          <el-table-column sortable prop="yxchl" label="已学词汇量" align="center"/>
          <el-table-column prop="kyxy" label="看英选义" align="center"/>
          <el-table-column prop="tyby" label="听音辨英" align="center"/>
          <el-table-column prop="kypc" label="看义拼词" align="center"/>
          <el-table-column prop="zwxy" label="看义选英" align="center"/>
          <el-table-column prop="sucs" label="熟词数" align="center"/>
          <el-table-column prop="jscs" label="夹生词数" align="center"/>
          <el-table-column prop="shcs" label="生词数" align="center"/>
          <el-table-column prop="xxsc" label="学习时长" align="center"/>
          <el-table-column prop="xspj" label="小时平均数" align="center"/>
          <el-table-column sortable prop="fs" label="综合成绩" align="center"/>
          <el-table-column prop="bgzt" label="报告状态" align="center" width="120px">
            <template v-slot="scope">
              <template v-if="scope.row.bgzt === 1">
                <el-link type="primary" @click="previewReport(scope.row)" style="cursor: pointer;">
                  √查看报告<i class="el-icon-view"></i>
                </el-link>
              </template>
              <template v-else>
                <el-link type="primary"><span style="color: red">×未上传</span></el-link>
              </template>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="300px">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" @click="lookStudentGrade(scope.row)">成绩详情</el-button>
              <el-button type="text" icon="el-icon-view" @click="lookStudentReport(scope.row)">学生报告</el-button>
              <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="uploadReport(scope.row)"
              >
                上传报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--        <div class="tea-pagination">-->
        <!--          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
        <!--                         :current-change='nodeClick' :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]"-->
        <!--                         :page-size="pages.pageSize" layout="total, sizes, prev, pager, next" :total="pages.total">-->
        <!--          </el-pagination>-->
        <!--        </div>-->
      </div>
      <!-- 测试成绩 -->
      <div class="test-table" v-show="model_type==2">
        <el-tabs tab-position="left" type="border-card" v-model="test_type_index" @tab-click='testTypeChange()'>
          <el-tab-pane label="测试类别" disabled class="first-no" name="3"></el-tab-pane>
          <el-tab-pane label="入学测试" name="0">
          </el-tab-pane>
          <el-tab-pane label="结业测试" name="1">
          </el-tab-pane>
        </el-tabs>
        <!-- 数据展示 -->
        <div class="table-data table">
          <el-table stripe border :data="testGradeData" height="calc(100% - 40px)">
            <el-table-column type="index" label="序号" width="50" align="center" :index="indexMethod"/>
            <el-table-column prop="xsxm" label="姓名" align="center"/>
            <!-- <el-table-column prop="xjh" label="学籍号" align="center" /> -->
            <!-- <el-table-column prop="xb" label="性别" align="center" /> -->
            <el-table-column prop="dtsl" label="答题数量" align="center"/>
            <el-table-column prop="ygchl" label="词汇量" align="center"/>
            <el-table-column prop="zql" label="正确率" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.zql + '%' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="wcrq" label="完成时间" align="center"/>
          </el-table>
          <div class="tea-pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize"
                           layout="total, sizes, prev, pager, next" :total="pages.total">
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 小组成绩 -->
      <div class="table" v-if="model_type==3&&(!history_group_show)">
        <el-table stripe border :data="groupGradeData" height="calc(100% - 40px)">
          <el-table-column type="index" label="序号" width="50" align="center" :index="indexMethod"/>
          <el-table-column prop="xzmc" label="小组名称" align="center"/>
          <el-table-column prop="xzid" label="小组编号" align="center"/>
          <el-table-column prop="cjrq" label="创建时间" align="center" v-if="model_type==3">
            <template slot-scope="scope">
              <span>{{ new Date(scope.row.cjrq).Format("yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="yzwsl" label="已掌握词汇量" align="center"/>
          <el-table-column prop="dcsl" label="已学词汇量" align="center"/>
          <el-table-column prop="pjchl" label="平均词汇量" align="center"/>
          <el-table-column prop="percentage" label="已掌握词汇进度" align="center" width="230px">
            <template slot-scope="scope" v-if="model_type==3">
              <el-progress :stroke-width="8" :percentage="formatPercentage(scope.row.dcsl,scope.row.yzwsl)*100"
                           :format="function(){return null}" :color="customColorMethod"></el-progress>
            </template>
          </el-table-column>
        </el-table>
        <div class="tea-pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize"
                         layout="total, sizes, prev, pager, next" :total="pages.total">
          </el-pagination>
        </div>
      </div>

      <!--      每日汇总-->
      <div class="table" v-if="model_type == 4">
        <div class="select-type">
          <el-radio-group v-model="model_export" style="margin-bottom: 20px;" @change="tabExport">
            <el-radio-button label="mastered">已掌握</el-radio-button>
            <el-radio-button label="learned">已学</el-radio-button>
            <el-radio-button label="daily">汇总</el-radio-button>
            <el-radio-button label="ai">数据概览</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 当选择数据概览合并表格 -->
        <el-table v-if="model_export === 'ai'" :data="combinedTableData" stripe border height="100%">
          <el-table-column
              v-for="(column, index) in tableColumns"
              :key="index"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
              :sortable="column.sortable"
              :type="column.type"
              align="center">
            <template slot-scope="scope">
              <!-- 统一处理所有列 -->
              <span v-if="column.isDate">
      {{ scope.row[column.prop] !== undefined ? scope.row[column.prop] : 0 }}
    </span>
              <span v-else-if="column.type === 'index'">
      {{ scope.$index + 1 }}
    </span>
              <span v-else>
      {{ scope.row[column.prop] }}
    </span>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else :data="studentsData" stripe border height="100%">
          <el-table-column type="index" label="序号" width="50" align="center"/>
          <el-table-column label="学生姓名" align="center">
            <template v-slot="scope">
              <span>{{ scope.row.xsxm }}</span>
            </template>
          </el-table-column>

          <el-table-column
              v-for="(dateData, index) in datesData"
              :key="index"
              align="center"
              :label="dateData.trainDate"
          >
            <template v-slot:header>
              <div>{{ dateData.trainDate }}</div>
              <div style="display: flex; justify-content: space-around;">
                <span v-if="shouldShowMastered">已掌握</span>
                <span v-if="shouldShowLearned">已学</span>
              </div>
            </template>
            <template v-slot="scope">
              <div style="display: flex; justify-content: space-around;">
            <span v-if="shouldShowMastered">{{
                getStudentScore(scope.row.xsxm, dateData.listStudent, 'yzwsl') || 0
              }}</span>
                <span v-if="shouldShowLearned">{{
                    getStudentScore(scope.row.xsxm, dateData.listStudent, 'yxsl') || 0
                  }}</span>
              </div>
            </template>
          </el-table-column>


          <el-table-column
              v-if="shouldShowMastered"
              label="已掌握合计"
              align="center"
          >
            <template v-slot:header>
          <span style="cursor: pointer">
            已掌握合计
            <i class="el-icon-d-caret" style="color: skyblue" @click="sortTable('totalMastered')"></i>
          </span>
            </template>
            <template v-slot="scope">
              <span>{{ scope.row.totalMastered || 0 }}</span>
            </template>
          </el-table-column>

          <!-- 已学合计列 -->
          <el-table-column
              v-if="shouldShowLearned"
              label="已学合计"
              align="center"
          >
            <template v-slot:header>
          <span style="cursor: pointer">
            已学合计
            <i class="el-icon-d-caret" style="color: skyblue" @click="sortTable('totalLearned')"></i>
          </span>
            </template>
            <template v-slot="scope">
              <span>{{ scope.row.totalLearned || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="学习时长" align="center">
            <template v-slot="scope">
              <span>{{ scope.row.xxsc }}</span>
            </template>
          </el-table-column>
          <el-table-column label="小时平均数" align="center">
            <template v-slot="scope">
              <span>{{ scope.row.xspj }}</span>
            </template>
          </el-table-column>
        </el-table>


      </div>


      <!-- 班级成绩的个人详情pop -->
      <el-dialog :title="stu_infor.xsxm" :visible.sync="student_obj.dialogVisible" width='80%' height='80%'
                 :modal-append-to-body="true" class="tea-diolag coin-diolag2">
        <div class="stu-table">
          <!-- {{tree_props}} -->
          <el-tree ref="tree" style="width:220px" node-key="keyId" :accordion='true'
                   :current-node-key='current_node_key' @node-click='nodeClick' :props="defaultProps"
                   :highlight-current='true' :load="loadNode" :data="tree_props" lazy>
          </el-tree>
          <!-- 数据展示 -->
          <div class="table-data table">
            <el-table stripe border :data="student_obj.tableData" height="calc(100% - 50px)">
              <el-table-column type="index" label="序号" align="center" width="50" :index="indexMethod"/>
              <el-table-column prop="lxmc" label="类型" align="center"/>
              <el-table-column prop="bbmc" label="版本" align="center"/>
              <el-table-column prop="zmc" label="章节" align="center" width="180"/>
              <el-table-column prop="dymc" label="单元" align="center"/>
              <el-table-column prop="yzwl" label="已掌握词汇量" align="center"/>
              <el-table-column prop="dcsl" label="已学词汇量" align="center"/>
              <el-table-column prop="kyxy" label="看英选义" align="center"/>
              <el-table-column prop="tyby" label="听音辨英" align="center"/>
              <el-table-column prop="kypc" label="看义拼词" align="center"/>
              <el-table-column prop="zwxy" label="中文选英" align="center"/>
              <el-table-column prop="fs" label="综合" align="center"/>
            </el-table>
            <div class="tea-pagination">
              <el-pagination @size-change="stuHandleSizeChange" @current-change="stuHandleCurrentChange"
                             :current-page="student_obj.pages.currentPage" :page-sizes="[10, 20, 30, 40]"
                             :page-size="student_obj.pages.pageSize" layout="total, sizes, prev, pager, next"
                             :total="student_obj.pages.total">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 历史小组成绩 -->
      <div class="history-box" v-if="history_group_show" v-loading='is_loading'>
        <el-empty description="暂无历史小组数据" class="empty" v-show="history_group_data.length==0"></el-empty>
        <div class="history-group">
          <div v-for="(item,index) in history_group_data" :key="index">
            <div class="history-title">{{ new Date(item.sksj).Format("yyyy-MM-dd hh:mm:ss") }} --
              {{ new Date(item.xksj).Format("yyyy-MM-dd hh:mm:ss") }}
            </div>
            <el-table class="history-table" stripe border :data="item.groupRespList">
              <el-table-column type="index" label="序号" width="50" align="center"/>
              <el-table-column prop="xzmc" label="小组名称" align="center"/>
              <el-table-column prop="xzid" label="小组编号" align="center"/>
              <el-table-column prop="cjrq" label="创建时间" align="center">
                <template slot-scope="scope">
                  <span>{{ new Date(scope.row.cjrq).Format("yyyy-MM-dd") }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="yzwsl" label="已掌握词汇量" align="center"/>
              <el-table-column prop="dcsl" label="已学词汇量" align="center"/>
              <el-table-column prop="pjchl" label="平均词汇量" align="center"/>
              <el-table-column prop="percentage" label="已掌握词汇进度" align="center" width="230px">
                <template slot-scope="scope">
                  <el-progress :stroke-width="8" :percentage="formatPercentage(scope.row.dcsl,scope.row.yzwsl)*100"
                               :format="function(){return null}" :color="customColorMethod"></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :title="previewTitle"
        :visible.sync="previewVisible"
        width="50%"
        top="5vh"
        :before-close="handlePreviewClose">

      <!-- 生成中状态 -->
      <div v-if="generating" class="generating-container">
        <div class="generating-spinner">
          <i class="el-icon-loading"></i>
        </div>
        <p class="generating-text">{{ generatingText }}</p>
      </div>

      <!-- 预览内容 -->
      <div v-else>
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane label="网页预览" name="html">
            <div class="preview-container">
              <iframe
                  v-if="htmlPreviewUrl"
                  :src="htmlPreviewUrl"
                  frameborder="0"
                  class="preview-iframe"
                  @load="onIframeLoad">
              </iframe>
              <div v-else class="no-preview">
                <i class="el-icon-document"></i>
                <p>暂无网页预览内容</p>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="PDF下载" name="pdf">
            <div class="download-container">
              <el-button
                  type="primary"
                  @click="downloadPdfReport"
                  size="large"
                  :loading="pdfLoading">
                <i class="el-icon-download"></i> 下载PDF报告
              </el-button>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Word下载" name="word">
            <div class="download-container">
              <el-button
                  type="primary"
                  @click="downloadWordReport"
                  size="large"
                  :loading="wordLoading">
                <i class="el-icon-download"></i> 下载Word报告
              </el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!--      <span slot="footer" class="dialog-footer">-->
      <!--      <el-button @click="handlePreviewClose">关 闭</el-button>-->
      <!--    </span>-->
    </el-dialog>
    <!-- 上传报告弹窗组件 -->
    <uploadReport
        :visible="showUploadDialog"
        :current-students="currentStudents"
        :user-id="yhid"
        :zhid="zhid"
        :xsid="xsid"
        :jxid="jxid"
        :bjid="bjid"
        :tab-type="tab_pane_index"
        @close="handleUploadDialogClose"
        @success="handleUploadSuccess"
    />

    <!-- 预览报告弹窗组件 -->
    <previewReport
        :visible="showPreviewDialog"
        :current-students="currentStudents"
        :tab-type="tab_pane_index"
        @close="handlePreviewDialogClose"
        @delete-success="handleDeleteSuccess"
    />
  </div>
</template>
<script>
import {
  classTempStudentGradeListApi,//班级成绩
  classTempStudentTestListApi,//测试成绩
  classTempGroupGradeApi,//小组成绩
  classTempGroupHistoryListApi,//历史小组成绩
  // ----------------------------------个人成绩详情
  wordTypeOptionsApi,// 单词类型下拉
  wordEditionOptionsApi,//单词版本下拉
  wordChapterOptionsApi,//单词章节
  classTempStudentGradeInforApi,//个人成绩详情
  dailyWordStatistics,
  getUserToken
} from '@/api/teacher'
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {MessageBox} from 'element-ui';
import ReportWorker from '@/utils/gradeReport';

export default {
  components: {
      uploadReport: (resolve) => {
        require(["@/components/teacher/class/uploadReport.vue"], resolve)
      },
      previewReport: (resolve) => {
        require(["@/components/teacher/class/previewReport.vue"], resolve)
      },
  },
  data() {
    return {
      xsid: '',
      tab_pane_index: 'students',
      currentSort: {      // 当前排序状态
        prop: null,       // 排序字段（如 'yzwl'）
        order: null       // 排序方式（'ascending'/'descending'）
      },
      model_type: '1',//1班级成绩 2测试成绩 3小组成绩
      model_export: 'daily',
      select: '',
      yhid: this.$store.state.userInfo.yhid,
      zhid: this.$store.state.userInfo.zhid,
      bjlx: this.$route.query.lx,
      bjid: this.$route.query.bjid,
      bjmc: this.$route.query.bjmc,
      jxid: this.$route.query.jxid,
      //   日期和关键字
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: this.$route.query.bjid,
        bjmc: this.$route.query.bjmc,
        xsxm: null,
      },
      time_list: [
        this.$route.query.yxqq, this.$route.query.yxqz,
      ],
      time_section: [this.$route.query.yxqq, this.$route.query.yxqz,],
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
      },
      classGradeData: [],//班级成绩
      testGradeData: [],//测试成绩
      groupGradeData: [],//小组成绩
      //   分页数据
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // --------------------测试成绩
      test_type_index: '0',
      // ------------------------------学生个人成绩详情
      student_obj: {
        title: '',
        dialogVisible: false,
        tableData: [],
        pages: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      },
      tree_props: [],
      tree_obj: [],
      current_node_key: 1,//
      current_node_key1: null,//类型
      current_node_key2: null,//版本
      current_node_key3: null,//章节
      defaultProps: {
        children: 'children',
        label: 'mc',
        isLeaf: function (data, node) {
          if (node.level < 3) {
            return false
          } else {
            return true
          }
        },
      },
      stu_infor: {
        //   xsid: '1224',
        //   xsxm: '陈7',
      },
      //---------------------------- 历史小组成绩数据
      is_loading: false,
      history_group_show: false,
      history_group_data: [],
      datesData: [],
      sortOrder: 'asc',
      currentSortField: null,
      report: {
        learnedText: '',
        masteredText: ''
      },
      previewVisible: false,
      previewTitle: '学生报告预览',
      generating: false,
      generatingText: '报告生成中，请稍候...',
      activeTab: 'html',
      htmlPreviewUrl: '',
      currentReportData: null,
      currentRowData: null,
      pdfLoading: false,
      wordLoading: false,
      currentReportType: '',
      combinedText: '',
      creationDate: '',
      showUploadDialog: false,
      showPreviewDialog: false,
      currentStudents: null,
      combinedTableData: [], //Ai投喂需求合并后的表格数据
    }
  },
  created() {

  },
  computed: {
    tableColumns() {
      const columns = [
        {prop: 'index', label: '序号', type: 'index', width: '60'},
        {prop: 'xsxm', label: '姓名', width: '100'},
        {prop: 'xb', label: '性别', width: '60'},
        {prop: 'yxchl', label: '词汇量', sortable: true, width: '80'},
        {prop: 'xxsc', label: '学习时长', width: '120'},
        {prop: 'xspj', label: '平均时速', width: '80'},
        {prop: 'kyxy', label: '看英选义', width: '80'},
        {prop: 'tyby', label: '听音辨英', width: '80'},
        {prop: 'kypc', label: '看义拼词', width: '80'},
        {prop: 'zwxy', label: '看义选英', width: '80'}
      ];

      const dateColumns = this.datesData.map(d => ({
        prop: d.trainDate,
        label: d.trainDate,
        width: '120',
        isDate: true
      }));

      // 在索引10之后插入所有日期列
      columns.splice(10, 0, ...dateColumns);

      return columns;
    },
    shouldShowMastered() {
      return this.model_export === 'mastered' || this.model_export === 'daily';
    },
    shouldShowLearned() {
      return this.model_export === 'learned' || this.model_export === 'daily';
    },
    studentsData() {
      const studentNames = [
        ...new Set(
            this.datesData.flatMap(dateObj =>
                dateObj.listStudent.map(student => student.xsxm)
            )
        ),
      ];

      return studentNames.map(xsxm => {
        const scores = this.datesData.map(dateObj => {
          const student = dateObj.listStudent.find(student => student.xsxm === xsxm);
          return student
              ? {yzwsl: student.yzwsl, yxsl: student.yxsl}
              : {yzwsl: null, yxsl: null};
        });

        const totalMastered = scores.reduce((total, score) => total + (score.yzwsl || 0), 0);
        const totalLearned = scores.reduce((total, score) => total + (score.yxsl || 0), 0);

        const classStudent = this.classGradeData.find(student => student.xsxm === xsxm);
        const xxsc = classStudent?.xxsc || 0;
        const xspj = classStudent?.xspj || 0;
        return {
          xsxm, scores, totalMastered, totalLearned, xxsc, xspj
        };
      });
    }
  },


  mounted() {
    this.pages.pageSize = 10;
    this.handelSearch()
    this.getWordTypeOptions()
    this.getDailyWord()
  },
  beforeDestroy() {
    this.handlePreviewClose();
  },
  methods: {
    sortTable(field) {
      if (this.currentSortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSortField = field;
        this.sortOrder = 'asc';
      }

      this.studentsData.sort((a, b) => {
        const fieldA = a[field] || 0;
        const fieldB = b[field] || 0;

        if (this.sortOrder === 'asc') {
          return fieldA - fieldB;
        } else {
          return fieldB - fieldA;
        }
      });
    },
// 合并班级成绩和每日汇总关键数据
    mergeTableData() {
      console.log('开始合并数据...');
      console.log('班级成绩数据长度:', this.classGradeData.length);
      console.log('每日汇总数据长度:', this.datesData.length);

      if (!this.classGradeData.length || !this.datesData.length) {
        this.combinedTableData = [];
        return;
      }

      console.log('班级成绩数据:', JSON.parse(JSON.stringify(this.classGradeData)));
      console.log('每日汇总数据:', JSON.parse(JSON.stringify(this.datesData)));

      const dates = this.datesData.map(item => item.trainDate);
      console.log('所有日期:', dates);

      const studentMap = new Map();

      this.classGradeData.forEach(student => {
        console.log(`处理班级学生: ${student.xsxm}`);
        studentMap.set(student.xsxm, {
          xsxm: student.xsxm,
          xb: student.xb === 1 ? '男' : student.xb === 2 ? '女' : '未知',
          yxchl: student.yxchl || 0,
          xxsc: student.xxsc || '0',
          xspj: student.xspj || 0,
          kyxy: student.kyxy || 0,
          tyby: student.tyby || 0,
          kypc: student.kypc || 0,
          zwxy: student.zwxy || 0,
          dailyData: {}
        });
      });

      console.log('初始化后的studentMap大小:', studentMap.size);

      // 处理每日汇总数据
      this.datesData.forEach(dateItem => {
        const date = dateItem.trainDate;
        console.log(`处理日期 ${date} 的数据，学生数量:`, dateItem.listStudent.length);

        dateItem.listStudent.forEach(student => {
          if (studentMap.has(student.xsxm)) {
            const studentData = studentMap.get(student.xsxm);
            studentData.dailyData[date] = student.yxsl || 0;
            console.log(`学生 ${student.xsxm} 在 ${date} 的已学词汇量:`, student.yxsl);
          } else {
            console.log(`警告: 学生 ${student.xsxm} 在班级成绩中不存在`);
          }
        });
      });

      // 转换为表格数据格式
      this.combinedTableData = Array.from(studentMap.values()).map(student => {
        const rowData = {
          xsxm: student.xsxm,
          xb: student.xb,
          yxchl: student.yxchl,
          xxsc: student.xxsc,
          xspj: student.xspj,
          kyxy: student.kyxy,
          tyby: student.tyby,
          kypc: student.kypc,
          zwxy: student.zwxy,
        };

        dates.forEach(date => {
          rowData[date] = student.dailyData[date] || 0;
        });

        return rowData;
      });

      if (this.combinedTableData.length > 0) {
        console.log(JSON.parse(JSON.stringify(this.combinedTableData[0])));
      }

      // 按词汇量排序
      this.combinedTableData.sort((a, b) => b.yxchl - a.yxchl);
      console.log(this.combinedTableData.sort((a, b) => b.yxchl - a.yxchl), '我是需要传递的数据')
    },
    tabExport(value) {
      if (value === 'mastered') {
        this.model_export = ''
        this.model_export = 'mastered'
      } else if (value === 'learned') {
        this.model_export = ''
        this.model_export = 'learned'
      } else if (value === 'daily') {
        this.model_export = ''
        this.model_export = 'daily'
      } else if (value === 'ai') {
        this.model_export = ''
        this.model_export = 'ai'
        this.mergeTableData();
      }
    },
    //
    // 导出excel，根据model_export的值决定导出哪个表格
    exportToExcel() {
      if (this.model_export === 'ai') {
        // 导出AI报表的合并表格
        this.exportAIReportToExcel();
      } else {
        // 导出原有的每日汇总表格
        this.exportDailyToExcel();
      }
    },

// 新增：导出AI报表的合并表格
    exportAIReportToExcel() {
      if (!this.combinedTableData.length) {
        this.$message.warning('暂无AI报表数据可导出');
        return;
      }

      const dates = this.datesData.map(d => d.trainDate);
      const exportData = [];

      // 表头
      const headers = ['序号', '姓名', '性别', '词汇量', '学习时长', '平均时速',
        '看英选义', '听音辨英', '看义拼词', '看义选英', ...dates];
      exportData.push(headers);

      // 数据行
      this.combinedTableData.forEach((item, index) => {
        const row = [
          index + 1,
          item.xsxm,
          item.xb,
          item.yxchl,
          item.xxsc,
          item.xspj,
          item.kyxy,
          item.tyby,
          item.kypc,
          item.zwxy
        ];

        // 添加每日数据
        dates.forEach(date => {
          row.push(item[date] || 0);
        });

        exportData.push(row);
      });

      const worksheet = XLSX.utils.aoa_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'AI报表数据');
      XLSX.writeFile(workbook, 'AI报表数据.xlsx');
      this.$message.success('AI报表导出成功');
    },

    exportDailyToExcel() {
      const exportData = [];
      const firstRowHeaders = ['序号', '学生姓名'];
      const secondRowHeaders = ['', ''];

      // 添加日期列
      this.datesData.forEach(date => {
        if (this.model_export === 'mastered') {
          firstRowHeaders.push(`${date.trainDate}`);
          secondRowHeaders.push('已掌握');
        } else if (this.model_export === 'learned') {
          firstRowHeaders.push(`${date.trainDate}`);
          secondRowHeaders.push('已学');
        } else {
          firstRowHeaders.push(`${date.trainDate}`, '');
          secondRowHeaders.push('已掌握', '已学');
        }
      });

      // 添加合计列
      if (this.model_export === 'mastered') {
        firstRowHeaders.push('已掌握合计');
        secondRowHeaders.push('');
      } else if (this.model_export === 'learned') {
        firstRowHeaders.push('已学合计');
        secondRowHeaders.push('');
      } else {
        firstRowHeaders.push('已掌握合计', '已学合计');
        secondRowHeaders.push('', '');
      }

      // 添加学习时长和小时平均数列头
      firstRowHeaders.push('学习时长', '小时平均数');
      secondRowHeaders.push('', '');

      exportData.push(firstRowHeaders);
      exportData.push(secondRowHeaders);

      // 添加数据行
      this.studentsData.forEach((student, index) => {
        const row = [index + 1, student.xsxm];

        // 添加每个日期的数据
        student.scores.forEach(score => {
          if (this.model_export === 'mastered') {
            row.push(score.yzwsl || 0);
          } else if (this.model_export === 'learned') {
            row.push(score.yxsl || 0);
          } else {
            row.push(score.yzwsl || 0, score.yxsl || 0);
          }
        });

        // 添加合计数据
        if (this.model_export === 'mastered') {
          row.push(student.totalMastered || 0);
        } else if (this.model_export === 'learned') {
          row.push(student.totalLearned || 0);
        } else {
          row.push(student.totalMastered || 0, student.totalLearned || 0);
        }

        // 添加学习时长和小时平均数
        row.push(student.xxsc || 0, student.xspj || 0);

        exportData.push(row);
      });

      const worksheet = XLSX.utils.aoa_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '学生成绩');
      XLSX.writeFile(workbook, '学生成绩.xlsx');
    },

    //升降序
    handleSortChange({column, prop, order}) {
      this.currentSort = {prop, order};
    },

    exportToExcelClass() {

      let sortedData = [...this.classGradeData];
      if (this.currentSort.prop && this.currentSort.order) {
        sortedData.sort((a, b) => {
          const valA = a[this.currentSort.prop];
          const valB = b[this.currentSort.prop];
          return this.currentSort.order === 'ascending'
              ? valA - valB  // 升序
              : valB - valA;  // 降序
        });
      }
      // 未点击排序，默认按 yzwl 降序
      else {
        sortedData.sort((a, b) => b.yzwl - a.yzwl);
      }
      // 2. 定义表头
      const headers = ['姓名', '性别', '常规班', '已掌握词汇量', '已学词汇量', '看英选义', '听音辨英', '看义拼词', '看义选英', '熟词数', '夹生词数', '生词数', '综合成绩', '学习时长', '小时平均数'];

      // 3. 处理数据（使用排序后的数据）
      const exportData = sortedData.map(item => [
        item.xsxm,
        item.xb === 1 ? '男' : item.xb === 2 ? '女' : '未知',
        item.bjmc,
        item.yzwl,
        item.yxchl,
        item.kyxy,
        item.tyby,
        item.kypc,
        item.zwxy,
        item.sucs,
        item.jscs,
        item.shcs,
        item.fs,
        item.xxsc,
        item.xspj,
      ]);
      // 4. 添加表头
      exportData.unshift(headers);

      // 5. 生成 Excel
      const worksheet = XLSX.utils.aoa_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '班级成绩');

      // 6. 导出文件
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
      const data = new Blob([excelBuffer], {type: 'application/octet-stream'});

      const link = document.createElement('a');
      const url = URL.createObjectURL(data);
      link.href = url;
      link.download = '班级成绩.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
// 格式化数组数据
    formatStudentData(dataArr) {
      let learnedTexts = []
      let masteredTexts = []
      dataArr.forEach(item => {
        const date = item.trainDate
        if (item.listStudent && item.listStudent.length > 0) {
          item.listStudent.forEach(stu => {
            learnedTexts.push(`${stu.xsxm} 在 ${date} 已学习 ${stu.yxsl} 个词汇`)
            masteredTexts.push(`${stu.xsxm} 在 ${date} 已掌握 ${stu.yzwsl} 个词汇`)
          })
        }
      })

      return {
        learnedText: learnedTexts.join('；\n'),
        masteredText: masteredTexts.join('；\n')
      }
    },
    async getDailyWord() {
      const {result, resultCode} = await dailyWordStatistics({bjid: this.bjid, jxid: this.jxid})
      if (resultCode === 200) {
        this.datesData = result
        console.log(this.datesData, '我是每日汇总')
        // 如果当前是AI报表模式，则合并数据
        if (this.model_export === 'ai') {
          this.mergeTableData();
        }

        this.report = this.formatStudentData(this.datesData)

        const learnedArr = (this.report.learnedText || '').trim().split('；').filter(Boolean)
        const masteredArr = (this.report.masteredText || '').trim().split('；').filter(Boolean)

        const combinedMap = {}

        learnedArr.forEach(line => {
          // 去掉首尾空格
          const clean = line.trim()
          if (!clean) return

          // 用学生名 + 日期 作为唯一 key
          const key = clean.split('已学习')[0].trim()
          combinedMap[key] = combinedMap[key] || {}
          combinedMap[key].learned = clean
        })

        masteredArr.forEach(line => {
          const clean = line.trim()
          if (!clean) return
          const key = clean.split('已掌握')[0].trim()
          combinedMap[key] = combinedMap[key] || {}
          combinedMap[key].mastered = clean
        })

        this.combinedText = Object.values(combinedMap).map(item => {
          return `${item.learned || ''}； ${item.mastered || ''}`
        }).join('\n')

        // console.log("===已学+已掌握===")
        // console.log(this.combinedText)
        // console.log("===已学段落===")
        // console.log(this.report.learnedText)
        // console.log("===已掌握段落===")
        // console.log(this.report.masteredText)
      }
    },

    async lookSummaryReport() {
      let type = ''
      if (this.model_export === 'mastered') {
        type = 'mastered'
      } else if (this.model_export === 'learned') {
        type = 'learned'
      } else if (this.model_export === 'daily') {
        type = 'daily'
      }
      console.log(type, 11111)
      this.currentReportType = type;
      let reportText = '';

      switch (type) {
        case 'mastered':
          reportText = this.report.masteredText;
          break;
        case 'learned':
          reportText = this.report.learnedText;
          break;
        case 'daily':
          reportText = this.combinedText;
          break;
      }
      const currentRowData = sessionStorage.getItem("userInfo")

      // 显示生成中状态
      this.showGeneratingState();

      try {
        const htmlContent = await ReportWorker.fetchAIReport(reportText, this.currentRowData.zhmc);

        // 存储报告数据
        this.currentReportData = {
          htmlContent,
        };

        const schoolName = this.currentRowData.zhmc || "未知学校";
        const today = new Date().toISOString().split("T")[0];
        // 替换为本地
        let personalizedContent = htmlContent
            .replace('<h1>校长数字画像报告</h1>', `<h1>${schoolName}的学生单词画像报告</h1>`)
            .replace(/<p[^>]*>.*?评估对象：.*?<\/p>/i, `<div style="margin-bottom: 20px;">
<p><strong>评估对象：</strong>${schoolName}</p>
<p><strong>报告日期：</strong>${today}</p>
</div>`);

        // 生成网页预览URL
        this.htmlPreviewUrl = URL.createObjectURL(
            new Blob([personalizedContent], {type: 'text/html'})
        );

        // 完成生成
        this.completeGeneration();

      } catch (error) {
        console.error('生成报告失败:', error);
        this.handleGenerationError(error.message || '报告生成失败，请重试');
      }
    },
    getStudentScore(xsxm, listStudent, key) {
      const student = listStudent.find(student => student.xsxm === xsxm);
      return student ? student[key] : null;
    },
    // 日期的禁选
    dealDisabledDate(time) {
      let srart = new Date(this.$utils.getNowTime(0, 0, -1, this.time_section[0])).getTime();
      let now = new Date(this.$utils.getNowTime(0, 0, 0,)).getTime()
      let end = new Date(this.time_section[1]).getTime();
      if (now < end) {
        end = now
      }
      return time < srart || time > end
    },
    //切换tab栏
    tabClick() {
      this.history_group_show = false;
      this.time_list = [this.$route.query.yxqq, this.$route.query.yxqz,];
      this.search_data.xsxm = null;
      this.pages = {
        currentPage: 1,
        pageSize: 10,
        tatal: 0,
      }
      this.handelSearch()
    },
    testTypeChange() {
      this.tabClick()
    },
    // -----------------------------查询列表
    getGradeList() {
      const data = JSON.parse(JSON.stringify(this.search_data));
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;

      let api = classTempStudentGradeListApi;
      if (this.model_type == 1) {
        data.pageSize = 100;
        //   班级成绩
        api = classTempStudentGradeListApi;
        data.startTime = this.time_list[0];
        data.endTime = this.time_list[1];
        data.jxid = this.jxid
        this.fetchClassGradeData(data)
      } else if (this.model_type == 2) {
        //   测试成绩
        api = classTempStudentTestListApi;
        data.lx = Number(this.test_type_index);
        data.startTime = this.time_list[0];
        data.endTime = this.time_list[1];
        this.fetchTestGradeData(data)
      } else if (this.model_type == 3) {
        //   小组成绩
        api = classTempGroupGradeApi;
        data.xzmc = this.search_data.xsxm;
        data.jxid = this.jxid
        this.fetchGroupGradeData(data)
      }
    },
    // 请求班级成绩数据
    fetchClassGradeData(data) {
      classTempStudentGradeListApi(data)
          .then(response => {
            this.classGradeData = response.result.list;
            console.log(this.classGradeData, '我是需要处理的班级成绩')
            // 如果当前是AI报表模式，则合并数据
            if (this.model_export === 'ai') {
              this.mergeTableData();
            }
          })
    },

    // 请求测试成绩数据
    fetchTestGradeData(data) {
      classTempStudentTestListApi(data)
          .then(response => {
            this.testGradeData = response.result.list;
          })
    },

    // 请求小组成绩数据
    fetchGroupGradeData(data) {
      classTempGroupGradeApi(data)
          .then(response => {
            this.groupGradeData = response.result.list;
            this.creationDate = response.result.list[0].cjrq
          })
    },

    // 时间区间改变
    timeChange() {
      this.handelSearch()
    },
    //  ---------------------------分页查询
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getGradeList()
    },

    handleSizeChange2(val) {
      this.pages.pageSize = val;
    },
    handleCurrentChange2(val) {
      this.pages.currentPage = val;
    },
    // 点击查询
    handelSearch() {
      if (this.history_group_show) {
        this.getHistoeyGroupList()
      } else {
        this.pages.currentPage = 1;
        this.getGradeList()
      }

    },
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    formatPercentage(average, num) {
      if (average && num) {
        const percentage = (Number(num) / Number(average)).toFixed(2)
        return percentage
      }
      return 0
    },
    customColorMethod(percentage) {
      if (percentage < 50) {
        return '#E86452';
      } else if (percentage < 60) {
        return '#E6A23C';
      } else if (percentage < 70) {
        return '#5B8FF9';
      } else if (percentage < 80) {
        return '#6f7ad3';
      } else if (percentage < 90) {
        return '#5AD8A6';
      } else if (percentage > 90) {
        return '#67C23A';
      }
    },
    // -------------------------------点击查看学生个人成绩详情跳转
    // 单词类型下拉
    getWordTypeOptions() {
      const data = {
        bjid: this.bjid,
        yycdid: this.$store.state.yycdid,
      }
      wordTypeOptionsApi(data).then(res => {
        if (res.resultCode == 200) {
          this.tree_obj = res.result;
          this.tree_obj.forEach(item => {
            item.keyId = item.id + item.mc
          })
          this.tree_obj[0].keyId = 1;
          console.log(this.tree_props)
        }
      })
    },
    // 单词版本下拉
    // getWordEditionOptions(id) {
    //   const data = {
    //     bjid: this.bjid,
    //     yycdid: this.$store.state.yycdid,
    //     lxid: id
    //   }
    //   wordEditionOptionsApi(data).then(res => {
    //     if (res.resultCode == 200) {
    //       this.wordzgloptions = res.result;
    //       console.log(res.result)
    //     } else {
    //       this.$message.warning(res.resultDesc)
    //     }
    //   })
    // },
    // 单词章节下拉
    // getWordChapterOptions(id) {
    //   const data = {
    //     bjid: this.bjid,
    //     yycdid: this.$store.state.yycdid,
    //     lxid: id,
    //     bbid:bbid,
    //   }
    //   wordChapterOptionsApi(data).then(res => {
    //     if (res.resultCode == 200) {
    //       this.wordzgloptions = res.result;
    //       console.log(res.result)
    //     } else {
    //       this.$message.warning(res.resultDesc)
    //     }
    //   })
    // },
    // ------------------------------------------学生个人成绩详情

    async lookStudentReport(row) {
      console.log(row,1111)
      const {resultDesc} = await getUserToken({
        yhid: String(row.xsid),
      })
      try {
        const yycdid = sessionStorage.getItem('yycdid') || ''

        const userInfoStr = sessionStorage.getItem('userInfo')
        const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
        const token = resultDesc
        const jsmc = '学生'
        const realname = row.xsxm
        const yhid = row.xsid
        const yhm = row.xsxm
        const zhid = userInfo?.zhid || ''
        const zhmc = userInfo?.zhmc || ''

        const params = new URLSearchParams({
          token,
          jsmc,
          realname,
          yhid,
          yhm,
          zhid,
          zhmc,
          yycdid
        }).toString()
        // 根据当前网站域名选择报告服务域名
        const hostname = window.location.hostname
        let reportBaseUrl
        if (hostname.includes('idechat.com')) {
          reportBaseUrl = 'https://jxreport.idechat.com'
        } else if (hostname.includes('ideaigc.com')) {
          reportBaseUrl = 'https://jxreport.ideaigc.com'
        }
        const reportUrl = `${reportBaseUrl}/report/entry?${params}`
        // 新窗口打开
        window.open(reportUrl, '_blank')
      } catch (error) {
        console.error('加载页面失败', error)
      }
    },


    // 点击成绩详情
    lookStudentGrade(result) {
      this.student_obj.dialogVisible = true;
      this.stu_infor.xsid = result.xsid;
      this.stu_infor.xsxm = result.xsxm;
      this.current_node_key1 = this.tree_obj.id;
      this.current_node_key2 = null;
      this.current_node_key3 = null;
      this.$nextTick(() => {
        this.tree_props = this.tree_obj;
      })
      this.student_obj.pages.currentPage = 1;
      this.getStuGradeList()
    },
    //查看报告
    async lookReport() {
      console.log(this.classGradeData, '班级成绩')
      const fieldMap = {
        xsxm: "姓名",
        xb: "性别",
        bjmc: "常规班",
        yzwl: "已掌握词汇量",
        yxchl: "已学词汇量",
        kyxy: "看英选义",
        tyby: "听音辨英",
        kypc: "看义拼词",
        zwxy: "看义选英",
        xxsc: "学习时长",
        xspj: "小时平均数",
        fs: "综合成绩",
      };

      const genderMap = {1: "男", 2: "女"};
// 生成文本
      const textResult = this.classGradeData.map(item => {
        return Object.keys(fieldMap).map(key => {
          let val = key === 'xb' ? genderMap[item[key]] || '' : (item[key] ?? '');
          return `${fieldMap[key]}：${val}`;
        }).join('，');
      }).join('\n\n');

      console.log(textResult);

      // 保存当前行数据
      this.currentRowData = sessionStorage.getItem("userInfo");

      // 显示生成中状态
      this.showGeneratingState();

      try {
        const htmlContent = await ReportWorker.fetchAIReport(textResult, this.currentRowData.zhmc);

        // 存储报告数据
        this.currentReportData = {
          htmlContent,
        };
        const schoolName = this.currentRowData.zhmc || "未知学校";
        const today = new Date().toISOString().split("T")[0];
        // 替换为本地
        let personalizedContent = htmlContent
            .replace('<h1>校长数字画像报告</h1>', `<h1>${schoolName}的学生单词画像报告</h1>`)
            .replace(/<p[^>]*>.*?评估对象：.*?<\/p>/i, `<div style="margin-bottom: 20px;">
<p><strong>评估对象：</strong>$${schoolName}</p>
<p><strong>报告日期：</strong>${today}</p>
</div>`);

        // 生成网页预览URL
        this.htmlPreviewUrl = URL.createObjectURL(
            new Blob([personalizedContent], {type: 'text/html'})
        );

        // 完成生成
        this.completeGeneration();

      } catch (error) {
        console.error('生成报告失败:', error);
        this.handleGenerationError(error.message || '报告生成失败，请重试');
      }
    },

    // 显示生成中状态
    showGeneratingState() {
      this.generating = true;
      this.previewTitle = '生成报告中...';
      this.previewVisible = true;
      this.generatingText = '报告生成中，请稍候...';
    },

    // 完成报告生成
    completeGeneration() {
      this.generating = false;
      this.previewTitle = `${this.currentRowData.zhmc}的学习报告`;
      this.$message.success('报告生成成功');
    },

    // 处理生成错误
    handleGenerationError(message) {
      this.generating = false;
      this.previewVisible = false;
      this.$message.error(message || '报告生成失败');
    },

    // 下载PDF报告
    async downloadPdfReport() {
      if (!this.currentReportData) {
        this.$message.warning('请先生成报告');
        return;
      }

      this.pdfLoading = true;

      try {
        const pdfBlob = await ReportWorker.generatePdfFile(
            this.currentReportData.htmlContent,
            this.currentRowData.zhmc
        );

        const url = URL.createObjectURL(pdfBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.currentRowData.zhmc}_学习报告.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$message.success('PDF报告下载开始');
      } catch (error) {
        console.error('PDF生成失败:', error);
        this.$message.error('PDF生成失败，请重试');
      } finally {
        this.pdfLoading = false;
      }
    },

    // 下载Word报告
    async downloadWordReport() {
      if (!this.currentReportData) {
        this.$message.warning('请先生成报告');
        return;
      }

      this.wordLoading = true;

      try {
        const wordBlob = await ReportWorker.generateWordFile(
            this.currentReportData.htmlContent,
            this.currentRowData.zhmc
        );

        const url = URL.createObjectURL(wordBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.currentRowData.zhmc}_学习报告.docx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$message.success('Word报告下载开始');
      } catch (error) {
        console.error('Word生成失败:', error);
        this.$message.error('Word生成失败，请重试');
      } finally {
        this.wordLoading = false;
      }
    },

    // iframe加载完成回调
    onIframeLoad() {
      console.log('预览内容加载完成');
    },

    // 关闭预览模态框
    handlePreviewClose() {
      // 清理URL对象
      if (this.htmlPreviewUrl) {
        URL.revokeObjectURL(this.htmlPreviewUrl);
        this.htmlPreviewUrl = '';
      }

      this.previewVisible = false;
      this.currentReportData = null;
      this.pdfLoading = false;
      this.wordLoading = false;
    },


    // 获取个人成绩详情
    getStuGradeList() {
      const data = JSON.parse(JSON.stringify(this.search_data));
      data.currentPage = this.student_obj.pages.currentPage;
      data.pageSize = this.student_obj.pages.pageSize;
      data.startTime = this.time_list[0];
      data.endTime = this.time_list[1];
      data.xsid = this.stu_infor.xsid;
      data.xsxm = this.stu_infor.xsxm;
      data.lxid = this.current_node_key1;
      data.bbid = this.current_node_key2;
      data.zid = this.current_node_key3;
      data.jxid = this.jxid;
      classTempStudentGradeInforApi(data).then(res => {
        if (res.result) {
          console.log(res.result)
          this.student_obj.tableData = res.result.list;
          this.student_obj.pages.total = res.result.total
        }
      })
    },
    stuHandleSizeChange(val) {
      this.student_obj.pages.pageSize = val;
      this.student_obj.pages.currentPage = 1;
      this.getStuGradeList()
    },
    stuHandleCurrentChange(val) {
      this.student_obj.pages.currentPage = val;
      this.getStuGradeList()
    },
    nodeClick(result, node) {
      // console.log(result, node)
      if (node.level == 1) {
        this.current_node_key1 = node.data.id;
        this.current_node_key2 = null;
        this.current_node_key3 = null;
      } else if (node.level == 2) {
        this.current_node_key2 = node.data.id;
        this.current_node_key3 = null
      } else if (node.level > 2) {
        this.current_node_key3 = node.data.id;
      }
      this.student_obj.pages.currentPage = 1;
      this.getStuGradeList()
    },
    isLeaf(data, node) {
      // console.log(data, node)
    },
    loadNode(node, resolve) {
      console.log(node)
      if (node.level == 1) {
        // 点击一级
        const data = {
          bjid: this.bjid,
          yycdid: this.$store.state.yycdid,
          lxid: node.data.id
        }
        wordEditionOptionsApi(data).then(res => {
          if (res.resultCode == 200) {
            const arr = res.result;
            resolve(arr)
          } else {
            this.$message.warning(res.resultDesc)
          }
        })
      } else if (node.level == 2) {
        // 点击二级
        const data = {
          bjid: this.bjid,
          yycdid: this.$store.state.yycdid,
          lxid: this.current_node_key1,
          bbid: node.data.id
        }
        wordChapterOptionsApi(data).then(res => {
          if (res.resultCode == 200) {
            const arr = res.result;
            resolve(arr)
          } else {
            this.$message.warning(res.resultDesc)
          }
        })
      } else if (node.level > 2) {
        // 点击三级
        return resolve([])
      }
    },
    // ------------------------------------------------历史小组成绩
    getHistoeyGroupList() {
      this.history_group_show = true;
      this.is_loading = true;
      // 历史小组成绩
      const data = JSON.parse(JSON.stringify(this.search_data));
      data.jxid = this.jxid;
      data.xzmc = this.search_data.xsxm;
      data.startTime = this.time_list[0];
      data.endTime = this.time_list[1];
      delete data.xsxm;
      classTempGroupHistoryListApi(data).then(res => {
        if (res.result) {
          this.is_loading = false;
          this.history_group_data = res.result;
        }
      })
    },
    uploadReport(classInfo) {
      this.currentStudents = classInfo
      this.showUploadDialog = true
      this.xsid = classInfo.xsid
      console.log(classInfo, '11111')
    },

    previewReport(classInfo) {
      this.currentStudents = classInfo
      console.log(this.currentStudents, 999999)
      this.showPreviewDialog = true
    },

    handleUploadDialogClose() {
      this.showUploadDialog = false
      this.currentStudents = null
    },

    handleUploadSuccess(reportData) {
      // 更新表格数据
      const index = this.tableData.findIndex(item => item.bjid === this.currentStudents.bjid)
      if (index !== -1) {
        this.$set(this.tableData[index], 'hasReport', true)
        this.$set(this.tableData[index], 'reportUrl', reportData.reportUrl)
        this.$set(this.tableData[index], 'reportName', reportData.reportName)
        this.$set(this.tableData[index], 'reportId', reportData.reportId)
        this.$set(this.tableData[index], 'uploadTime', reportData.uploadTime)
        this.$set(this.tableData[index], 'fileSize', reportData.fileSize)
        this.$set(this.tableData[index], 'ossKey', reportData.ossKey)
      }

      this.showUploadDialog = false
      this.currentStudents = null
    },

    handlePreviewDialogClose() {
      this.showPreviewDialog = false
      this.currentStudents = null
    },

    handleDeleteSuccess(classInfo) {
      // 更新表格数据
      const index = this.tableData.findIndex(item => item.bjid === classInfo.bjid)
      if (index !== -1) {
        this.$set(this.tableData[index], 'hasReport', false)
        this.$set(this.tableData[index], 'reportUrl', '')
        this.$set(this.tableData[index], 'reportName', '')
        this.$set(this.tableData[index], 'reportId', '')
        this.$set(this.tableData[index], 'uploadTime', '')
        this.$set(this.tableData[index], 'fileSize', 0)
        this.$set(this.tableData[index], 'ossKey', '')
      }

      this.showPreviewDialog = false
      this.currentStudents = null
    },
    // -------------------------------------------------------分屏显示
    screenShow() {
      const pageSize = 2;
      const tatal_page_num = Math.ceil(this.groupGradeData.length / 2)
      console.log(tatal_page_num)
      for (let i = 1; i < tatal_page_num + 1; i++) {
        console.log('分屏显示')
        window.open('#/screen/splitScreen?bjid=' + this.bjid + '&bjmc=' + this.bjmc + '&zhid=' + this.zhid + '&yhid=' + this.yhid + '&jxid=' + this.jxid + '&currentPage=' + i + '&pageSize=' + pageSize + '&creationDate=' + this.creationDate, 'newwindows' + i, "height=800, width=1000, top=100, left=100,toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  background: #fff;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #409eff, #66b1ff);
  padding: 16px 24px;
  margin-right: 0;
}

::v-deep .el-dialog__title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 18px;
}

::v-deep .el-dialog__body {
  padding: 25px 30px;
  background-color: #f9fafc;
}

/* 生成中状态 */
.generating-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: linear-gradient(135deg, #f5f7fa, #eef3f7);
  border-radius: 8px;
}

.generating-spinner i {
  font-size: 42px;
  color: #409eff;
  margin-bottom: 15px;
  animation: spin 1.5s linear infinite;
}

.generating-text {
  font-size: 16px;
  color: #606266;
}

/* loading 动画 */
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/* 标签页 */
::v-deep .el-tabs--card > .el-tabs__header {
  border: none;
  margin-bottom: 20px;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-radius: 6px 6px 0 0;
  background: #f5f7fa;
  padding: 0 20px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  transition: all 0.3s;
  margin-right: 8px;
  //border: 1px solid #dcdfe6;
  border: none;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item:hover {
  color: #409eff;
  border-color: #a0cfff;
  transform: rotate(15deg);
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

/* 预览容器 */
.preview-container {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.preview-iframe {
  width: 100%;
  height: 500px;
  border: none;
}

.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 280px;
  background: #f5f7fa;
  border-radius: 10px;
}

.no-preview i {
  font-size: 60px;
  color: #909399;
  margin-bottom: 12px;
}

.no-preview p {
  font-size: 15px;
  color: #909399;
}

/* 下载区域 */
.download-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
  background: #f5f7fa;
  border-radius: 10px;
}

.download-container .el-button {
  padding: 14px 40px;
  font-size: 16px;
  border-radius: 28px;
  transition: all 0.3s;
}

.download-container .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.download-container .el-button i {
  margin-right: 8px;
  font-size: 20px;
}

/* 底部按钮 */
.dialog-footer {
  text-align: right;
  padding-top: 18px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button {
  padding: 10px 26px;
  border-radius: 6px;
  transition: all 0.2s;
}

.dialog-footer .el-button:hover {
  opacity: 0.9;
}

.grade-data {
  height: 100%;
  position: relative;
}

.tea-search {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.model-type {
  width: 100%;
  display: flex;
  // align-items: center;
  justify-content: space-between;

  .tea-btn {
    margin-bottom: 20px;

    &.el-button--primary {
      background-color: #5186c2;
      border-color: #5186c2;
    }
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #5186c2 !important;
    border: 1px solid #5186c2;
  }

  ::v-deep .el-radio-button__inner {
    font-size: 16px;
  }
}

.select-type {
  width: 100%;
  display: flex;
  // align-items: center;
  justify-content: space-between;

  .tea-btn {

    &.el-button--primary {
      background-color: #5186c2;
      border-color: #5186c2;
    }
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #5186c2 !important;
  }

  ::v-deep .el-radio-button__inner {
    font-size: 13px;
  }
}

.grade-box {
  height: calc(100% - 120px);
  // 前后测数据展示
  .test-table {
    width: 100%;
    height: 100%;
    display: flex;
    border: #eee solid 1px;

    .table-data {
      width: calc(100% - 120px);

      .el-table--border {
        border-top: none;
      }
    }

    ::v-deep .el-tabs {
      width: 120px;

      ::v-deep .el-tabs__content {
        display: none !important;
      }
    }

    ::v-deep .el-tabs--border-card {
      border: none;
      box-shadow: none;
    }

    ::v-deep .el-tabs__item:first-child {
      font-size: 16px;
      height: 45px;
      line-height: 45px;
      color: #999;
    }
  }

  // 历史小组成绩
  .history-box {
    height: 100%;
    width: 100%;

    .empty {
      height: calc(100% - 0px);
      background-color: #fff;
      opacity: 1;
    }

    .history-group {
      overflow: auto;
      height: calc(100% - 0px);

      .history-title {
        color: #555;
        font-weight: bold;
      }

      .history-table {
        margin: 15px 0;
      }
    }
  }
}

::v-deep .model-type .tea-btn.el-button--primary.is-disabled {
  opacity: 0.85;
}

.stu-table {
  width: 100%;
  height: 600px;
  display: flex;
  border: #eee solid 1px;

  .table-data {
    width: calc(100% - 150px);

    .el-table--border {
      border-top: none;
    }
  }

  ::v-deep .el-tabs {
    width: 150px;

    ::v-deep .el-tabs__content {
      display: none !important;
    }
  }

  ::v-deep .el-tabs--border-card {
    border: none;
    box-shadow: none;
  }

  ::v-deep .el-tabs__item:first-child {
    font-size: 16px;
    height: 45px;
    line-height: 45px;
    color: #999;
  }
}
</style>
